import axios from "axios";
import * as actionType from "../../../constant/actionType";
// import { fetchData,fetchDataSuccess, fetchDataError } from "../../redux/classes/client-portal/clientCsvSlice";
export const UpdateProviderDocStatus = (ApiData) => async (dispatch) => {
      try {
        const response = await axios({
          method: 'put',
          data: ApiData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
          },
          url: `${actionType.environment_url}/api/admin/provider/UpdateProviderDocStatus`,
        });
        return response.data
      } catch (error) {
        return error.response?.data || { success: false, message: error.message }
      }
    }